import type { DomainNavTabProps } from '@cmg/design-system';
import { DomainNavTab } from '@cmg/design-system';

import { ReactRouterMUINavLink } from './ReactRouterMUINavLink';

export type ReactRouterDomainNavTabProps = DomainNavTabProps<typeof ReactRouterMUINavLink>;
export function ReactRouterDomainNavTab(props: ReactRouterDomainNavTabProps) {
  return <DomainNavTab {...props} component={ReactRouterMUINavLink} />;
}
